import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";
import { Link, useNavigate, useParams } from "react-router-dom";

import "../../../Style/hypperViewStyle.css";
import { formatDate, getRecords } from "../../../services/api.service";
import { formContentContainer } from "../../../Style/loaderOverly";
import CustomForm from "../../../custom/Forms/CustomForm";

const InvoiceLogView = ({ args }) => {
  const breadcrumbItems = [];
  const { id } = useParams();
  const navigate = useNavigate();

  const [loadingData, setLoadingData] = useState(id ? true : false);

  const [logData, setLogData] = useState([]);
  const [expandedInwardLogs, setExpandedInwardLogs] = useState({});
  const [expandedMakeItems, setExpandedMakeItems] = useState({});
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    if (id) {
      getInvoiceLogs(id);
    }
  }, [id]);

  const getInvoiceLogs = async (Id) => {
    let payload = {
      modelName: "invoice_logs",
      whereCondition: {
        invoice_id: Id,
      },
    };

    const responseData = await getRecords(payload, "/getRecords");
    if (responseData.code == 1) {
      setLoadingData(false);
      setLogData(responseData?.data);
    }
  };

  const filteredItems =
    logData?.filter((item) =>
      item?.invoice_no?.toLowerCase().includes(searchKeyword.toLowerCase())
    ) || [];
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchKeyword(value);
  };
  const toggleInwardLog = (index) => {
    setExpandedInwardLogs((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleMakeItem = (key) => {
    setExpandedMakeItems((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <CustomForm
      title="Invoice Log"
      id={id}
      noBackButton
      noSubmitButton
      loadingData={loadingData}
    >
      <Row className="">
        <Col lg={12}>
          <div
            className="table mt-2"
            style={{
              overflowX: "auto",
              overflowY: "auto",
              maxHeight: "500px",
              width: "100%",
              scrollBehavior: "smooth",
              scrollbarWidth: "thin",
              msOverflowStyle: "none",
              zIndex: 0,
            }}
          >
            <table className="table">
              <thead
                style={{
                  backgroundColor: "#8AC1E8",
                  position: "sticky",
                  top: "0px",
                }}
              >
                <tr style={{ borderBottom: "1px solid black" }}>
                  <th style={{ whiteSpace: "nowrap" }}>Sr No</th>
                  <th style={{ whiteSpace: "nowrap" }}>Invoice No</th>
                  <th style={{ whiteSpace: "nowrap" }}>Warehouse Name</th>
                  <th style={{ whiteSpace: "nowrap" }}>Invoice Date</th>
                  <th style={{ whiteSpace: "nowrap" }}>Created By</th>
                  <th style={{ whiteSpace: "nowrap" }}>Status</th>
                  <th style={{ whiteSpace: "nowrap" }}>View</th>
                </tr>
              </thead>
              <tbody>
                {logData && logData.length > 0 ? (
                  logData.map((log, logIndex) => {
                    let serialNumber = 1;

                    return (
                      <React.Fragment key={logIndex}>
                        <tr>
                          <td>{logIndex + 1}</td>
                          <td
                            className="text-primary hover-pointer"
                            onClick={() =>
                              navigate(`/invoice-view/${log.invoice_id}`)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {log?.invoice_no}
                          </td>
                          <td>{log?.warehouse_name}</td>
                          <td>{formatDate(log?.invoice_date)}</td>
                          <td>{log?.created_by}</td>
                          <td>{log?.is_submitted}</td>
                          <td>
                            <Link
                              className="text-primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                toggleInwardLog(logIndex);
                              }}
                              style={{ cursor: "pointer" }}
                            >
                              <i
                                className={`mdi mdi-${
                                  expandedInwardLogs[logIndex]
                                    ? "minus"
                                    : "plus"
                                } font-size-22`}
                              ></i>
                            </Link>
                          </td>
                        </tr>

                        {expandedInwardLogs[logIndex] && (
                          <>
                            <tr
                              style={{
                                backgroundColor: "#E5F1FC",
                                fontWeight: "900",
                              }}
                            >
                              <th></th>
                              <th>Sr No</th>
                              <th>Item Code</th>
                              <th>Item Desc</th>
                              <th>QTY</th>
                              <th></th>
                              <th></th>
                            </tr>

                            {log.items.map((item, itemIndex) => {
                              const uniqueItemKey = `${logIndex}-${itemIndex}`;

                              return (
                                <React.Fragment key={uniqueItemKey}>
                                  <tr>
                                    <td></td>
                                    <td>{serialNumber++}</td>
                                    <td>
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "5px",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          whiteSpace: "nowrap",
                                          cursor:
                                            item?.type == 1
                                              ? "pointer"
                                              : "default",
                                        }}
                                        title={item?.make_item_code || "N/A"}
                                      >
                                        <span>
                                          {item?.make_item_code || "N/A"}
                                        </span>

                                        {item?.type == 1 && (
                                          <Link
                                            className="text-primary"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              toggleMakeItem(uniqueItemKey);
                                            }}
                                            style={{ cursor: "pointer" }}
                                          >
                                            <i
                                              className={`mdi mdi-chevron-${
                                                expandedMakeItems[uniqueItemKey]
                                                  ? "up"
                                                  : "down"
                                              } font-size-18`}
                                            ></i>
                                          </Link>
                                        )}
                                      </div>
                                    </td>
                                    <td>{item.make_item_desc}</td>
                                    <td>{item.qty}</td>

                                    <td></td>
                                    <td></td>
                                  </tr>

                                  {expandedMakeItems[uniqueItemKey] &&
                                    item.buy_items.map(
                                      (buyItem, buyItemIndex) => (
                                        <tr key={buyItemIndex}>
                                          <td></td>
                                          <td style={{ paddingLeft: "30px" }}>
                                            {`${serialNumber - 1}.${
                                              buyItemIndex + 1
                                            }`}
                                          </td>
                                          <td>{buyItem.buy_item_code}</td>
                                          <td>{buyItem.buy_item_desc}</td>
                                          <td>{buyItem.qty}</td>
                                          <td></td>
                                          <td></td>
                                        </tr>
                                      )
                                    )}
                                </React.Fragment>
                              );
                            })}
                          </>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>
                      No data available.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Col>
      </Row>
    </CustomForm>
  );
};

export default InvoiceLogView;
